module.exports = __webpack_public_path__ + "img/save-img.de8a97da.svg";